import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import EmployableHistoryCard from './EmployableHistoryCard/index';
import EmployableHistoryFilters from '../EmployableHistoryFilters';
import S from './styles';
import EmployableHistoryNoteModal from './employableHistoryNoteModal';

class EmployableHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOnlyNotes: false,
      isOnlyEditEvents: false,
      isAllEvents: true,
      noteActive: false,
    };
    this.toggleEventFilters = this.toggleEventFilters.bind(this);
  }

  toggleEventFilters = (filter) => {
    const { isOnlyNotes, isOnlyEditEvents } = this.state;
    if (filter === 'Notes') {
      if (isOnlyNotes) this.setState({ isOnlyNotes: false });
      else this.setState({ isAllEvents: false, isOnlyEditEvents: false, isOnlyNotes: true });
    }
    if (filter === 'Edit Events') {
      if (isOnlyEditEvents) this.setState({ isOnlyEditEvents: false });
      else this.setState({ isAllEvents: false, isOnlyEditEvents: true, isOnlyNotes: false });
    }
    if (filter === 'All') {
      this.setState({ isAllEvents: true, isOnlyEditEvents: false, isOnlyNotes: false });
    }
  };

  filterEventsList = () => {
    const { isOnlyNotes, isOnlyEditEvents, isAllEvents } = this.state;
    const { events = [] } = this.props.employable;
    let filteredEvents = [];
    if (isOnlyNotes) {
      filteredEvents = events.filter(event => event.kind === 'note');
    } else if (isOnlyEditEvents) {
      filteredEvents = events.filter(event => event.kind === 'update_profile');
    } else if (isAllEvents) filteredEvents = events;

    return filteredEvents;
  }

  groupEvents = () => {
    // Group By Profile Updates and Notes
    const { isOnlyNotes, isOnlyEditEvents } = this.state;
    const scopedEvents = {};
    const events = this.filterEventsList();
    if (isOnlyNotes) {
      // eslint-disable-next-line dot-notation
      scopedEvents['Notes'] = events;
      return scopedEvents;
    } else if (isOnlyEditEvents) {
      scopedEvents['Edit Events'] = events;
      return scopedEvents;
    }
    events.forEach((event) => {
      const scopeName = event.name === 'Update Profile' ? 'Edit Events' : 'Notes';
      if (!scopedEvents[scopeName]) scopedEvents[scopeName] = [];
      scopedEvents[scopeName].push(event);
    });
    return scopedEvents;
  }

  addNote = () => this.setState({ noteActive: true });

  closeNoteModal = () => this.setState({ noteActive: false })

  renderEmployableHistoryList = () => {
    const scopedEvents = this.groupEvents();
    return Object.keys(scopedEvents).map(name => <div key={name}>
      <EmployableHistoryCard
        name={name}
        employableType={this.props.employableType}
        events={scopedEvents[name]}
      />
    </div>);
  };

  render = () => {
    const { employableType, employable: { events = [] } } = this.props;
    const { noteActive, isOnlyNotes, isOnlyEditEvents, isAllEvents } = this.state;
    return (<Fragment>
      {['installer', 'estimator'].includes(employableType) && <div className={S.noteBtnAndFiltersContainer}>
        <button className={S.createNoteBtn} onClick={this.addNote}>Add Note</button>
        {noteActive && <EmployableHistoryNoteModal
          active={noteActive}
          employable={this.props.employable}
          employableType={employableType}
          closeNoteModal={this.closeNoteModal}
        />}
        {events.length !== 0 && <EmployableHistoryFilters
          toggleEventFilters={this.toggleEventFilters}
          isAllEvents={isAllEvents}
          isOnlyNotes={isOnlyNotes}
          isOnlyEditEvents={isOnlyEditEvents}
        />}
      </div>}
      {events.length === 0 ?
        <div className={S.emptyList}>History is Empty</div> :
        this.renderEmployableHistoryList()
      }
    </Fragment>);
  }
}

EmployableHistory.propTypes = {
  employable: PropTypes.object,
  employableType: PropTypes.string,
};

export default EmployableHistory;



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistory/index.jsx